export const timesheet = {
  prev_month: "<",
  next_month: ">",
  save: "Enregistrer",
  send_to_validator: "Envoyer au validateur",
  select_placeholder: "-- Sélectionnez --",
  leave_paid: "Congé payé",
  leave_unpaid: "Congé non payé",
  intern: "Intern",
  day: "Jour",
  total: "Total",
  actions: "Actions",
  save_line: "Enregistrer",
  edit_line: "Modifier",
  production: "Production",
  absences: "Absences",
  global_summary: "Résumé global",
  total_days: "Total jours",
  holidays: "Fériés",
  weekends: "Weekends",
  comments: "Commentaires",
  attachments: "Documents signés et pièces jointes",
  upload_text: "Déposez vos fichiers ici ou cliquez",
  upload_hint: "(Max: 20 fichiers de 15Mo)",
  cra_saved: "CRA enregistré ✅",
  cra_save_error: "Erreur lors de l'enregistrement ❌",
  email_sent_validator: "Email envoyé au validateur ✅",
  email_send_error: "Erreur lors de l'envoi ❌",
  write_comments: "Rédigez vos commentaires",
  loading: "Chargement...",
  timesheets_title: "Feuilles de temps",
  status_draft: "Brouillon",
  status_pending_validation: "En attente de validation",
  status_validated: "Validé",
  status_refused: "Refusé",
  status_pending: "⋯",
  period: "Période",
  state: "État",
};
